import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "eye", "eyeSlash"]

  toggle() {
    const visible = this.inputTarget.type === "text"
    this.inputTarget.type = visible ? "password" : "text"
    this.eyeTarget.classList.toggle("hidden", visible)
    this.eyeSlashTarget.classList.toggle("hidden", !visible)
  }
}
